import React from 'react'
import {AdminPageProps, withAdminPageTemplate} from './withAdminPageTemplate'
import {withDialog} from './withDialog'
import {withPageTitle} from './withPageTitle'
import {AsyncCommunicationProps, withAsyncCommunication} from './withAsyncCommunication'
import {withLoadingSpinner} from './withLoadingSpinner'
import {LoggerProps, withLogger} from './withLogger'
import {withScroller} from './withScroller'
import {RouterPageProps} from '../RouterPropsInjector'

export type AdminPagePropsSet =
    AdminPageProps &
    AsyncCommunicationProps &
    LoggerProps &
    RouterPageProps

export const createAdminPage = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps & AdminPagePropsSet>,
) =>
    withLogger(
        WrappedComponent.displayName || 'undefined',
        withAdminPageTemplate(
            withScroller(
                withAsyncCommunication(
                    withDialog(
                        withPageTitle(
                            withLoadingSpinner(
                                WrappedComponent)))))),
    )
